export default __webpack_public_path__ + "static/media/avatarCard.ba6ac561.svg";